module.exports = __webpack_public_path__ + "img/cattunnel32.75bc1337.jpg";